import 'css-chunksrc/client/common/numberInput/styles.scss';export default {
  "numberInput": "_numberInput_1cqp7_1"
};